import posed from "react-pose"

const PosedAppContent = posed.div({
  unmountedDown: { x: "30%" },
  unmountedUp: { x: "-30%" },
  mounted: { x: "0%", transition: { type: "tween", ease: "circOut", duration: 250 } },
})

export default PosedAppContent



// WEBPACK FOOTER //
// ./src/features/common/PosedAppContent.js